import script from "./HeroField.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeroField.vue?vue&type=script&setup=true&lang=ts"

import "./HeroField.vue?vue&type=style&index=0&id=27838424&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27838424"]])

export default __exports__